
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SIDEBAR_ITEMS, APP_LOGO } from '../constants';

const Sidebar: React.FC = () => {
  const location = useLocation();

  const renderSection = (title: string) => {
    const items = SIDEBAR_ITEMS.filter(item => item.section === title);
    return (
      <div className="mb-6" key={title}>
        <p className="px-3 text-xs font-semibold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
          {title}
        </p>
        <div className="space-y-1">
          {items.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-3 py-2.5 text-sm font-medium rounded-md transition-all ${
                  isActive
                    ? 'bg-primary/10 text-primary border-r-2 border-primary'
                    : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'
                }`}
              >
                <span className="material-icons-round text-[20px]">{item.icon}</span>
                {item.label}
              </Link>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <aside className="w-64 border-r border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 sticky top-0 h-screen overflow-y-auto custom-scrollbar flex-shrink-0 z-50">
      <div className="p-6 flex items-center gap-3">
        <img src={APP_LOGO} alt="Logo" className="w-10 h-10 rounded-lg shadow-sm" />
        <h1 className="font-bold text-xl tracking-tight text-slate-900 dark:text-white">TravelBook</h1>
      </div>
      <nav className="mt-4 px-3">
        {renderSection('Principal')}
        {renderSection('Operações')}
      </nav>
      <div className="p-6 mt-auto">
        <button 
          onClick={() => document.documentElement.classList.toggle('dark')}
          className="w-full flex items-center justify-center gap-2 p-2 rounded-lg border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-all"
        >
          <span className="material-icons-round text-sm">dark_mode</span>
          <span className="text-xs font-medium">Alternar Tema</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
